module.exports = __webpack_public_path__ + "img/bateriasincarga.e8d2989f.png";